import React, { useEffect, useRef, useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Dropdown as BootstrapDropdown,
} from "react-bootstrap";

import LogoImage from "../../assets/images/logo-gameification.svg";
import SearchIconImage from "../../assets/images/seach-icon-image.svg";
import LocationIcon from "../../assets/images/Location_Icon.svg";
import MessageIcon from "../../assets/images/message-header-icon.svg";
import NotificationIcon from "../../assets/images/notification-header-icon.svg";
import TrofieUserImage from "../../assets/images/trofies-profile-image.svg";
import CoinIcon from "../../assets/images/header-coin-icon.svg";
import CoinSmallIcon from "../../assets/images/coin-image.svg";
import ShoopingImage from "../../assets/images/shopping bag-fill.svg";
import Googleplaystore from "../../assets/images/play-store-icon.svg";
import Applestore from "../../assets/images/apple-store-icon.svg";
import { useSubscription } from "../../context/SubscriptionContext";

import { Input, Space, Menu, Drawer, Button, Switch, Dropdown } from "antd";
import {
  SettingOutlined,
  LogoutOutlined,
  BellOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  DownOutlined,
  DeploymentUnitOutlined,
} from "@ant-design/icons";
import CartListingDrawer from "../../pages/Cart/CartListing";
import { useNavigate } from "react-router";
import { AlignJustify } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useWallet } from "../../context/WalletContext";
import { useStore } from "../../context/StoreContext";
import CustomeModal from "../ModalComponant";
import { getCoordinates, getLocationDetails } from "../../helper/functions";
import { useChat } from "../../context/ChatContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import { useKYC } from "../../context/KycContext";

const Header = ({ onPress }) => {
  const [selectedLocation, setSelectedLocation] = useState();
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [kycDetails, setKycDetails] = useState();
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const { logout, loading, getProfile } = useAuth();
  const { loadWalletSummary, walletSummary } = useWallet();
  const { fetchKYC } = useKYC();
  // const [walletSummary, setWalletSummary] = useState(null);
  const [activeItem, setActiveItem] = useState("Profile");
  const { loadCartItems, cart, refreshCart } = useStore();
  const [cartItems, setCartItems] = useState([]);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [currentActiveAddress, setCurrentActiveAddress] = useState(null);
  const [open, setOpen] = useState(false);
  const { setGlobalSearch } = useGlobalSearch();
  const { getMyPlan } = useSubscription();
  const [profile, setProfile] = useState();
  const [searchInputText, setSearchInputText] = useState("");
  const pathName = window.location.pathname.split("/")[1];

  const locations = userProfile?.addresses?.map(
    (address) => address.streetAddress
  );
  locations?.unshift(currentActiveAddress?.city);

  const confirmLogout = () => {
    logout();
    setLogoutModalOpen(false);
  };

  const menuItems1 = [
    { label: "Profile", icon: <UserOutlined />, path: "/profile" },
    { label: "Your Orders", path: "/order" },
    { label: "Address", path: "/address" },
    { label: "Subscription", path: "/subscriptions" },
    { label: "Chats", path: "/chat" },
  ];

  const menuItems = [
    { label: "Connections", path: "/connections" },
    { label: "Leaderboard", path: "/leaderboard" },
    { label: "Wallet", path: "/wallet" },
    { label: "Your Orders", path: "/order" },
    { label: "Address", path: "/address" },
    { label: "Subscription", path: "/subscriptions" },
    { label: "Bids", path: "/my-bids" },
    { label: "KYC", path: "/kyc" },
    { label: "Logout", path: "/sign-in", isLogout: true },
  ];
  const menuItems2 = [
    {
      label: "Notifications",
      icon: <BellOutlined />,
      switch: <Switch size="small" defaultChecked={false} />,
      path: "/notifications",
    },
    {
      label: "Active Devices",
      icon: <AppstoreAddOutlined />,
      path: "/active-devices",
    },
    {
      label: "Help Center",
      icon: <QuestionCircleOutlined />,
      path: "/help-center",
    },
    { label: "Submit Feedback", icon: <FileTextOutlined />, path: "/feadback" },
    {
      label: "Platform Policies",
      icon: <DeploymentUnitOutlined />,
      path: "/platform-policies",
    },
    {
      label: "Logout",
      icon: <LogoutOutlined />,
      path: "logout",
      isLogout: true,
    },
  ];

  // ------------ handlers ---------------

  const handleMenuClick = (e) => {
    setSelectedLocation(locations[e.key]);
  };

  const handleClick = (label, path, isLogout = false) => {
    setActiveItem(label);
    if (isLogout) {
      // open modal instead of logout directly
      setLogoutModalOpen(true);
    } else {
      navigate(path);
    }
  };

  const loadCartItemsData = async () => {
    const response = await loadCartItems();
    setCartItems(response?.data);
  };

  const locationMenu = (
    <Menu onClick={handleMenuClick}>
      {locations?.map((loc, index) => (
        <Menu.Item key={index}>{loc}</Menu.Item>
      ))}
    </Menu>
  );

  // const loadWalletData = async () => {
  //   const response = await loadWalletSummary();
  //   setWalletSummary(response?.data);
  // };

  const loadMyPlan = async () => {
    try {
      const profileData = await getProfile();
      if (profileData.status === 200) {
        setProfile(profileData.data);
      }
      const plan = await getMyPlan();
      setSubscriptionPlan(plan?.data?.data?.subscription?.planSnapshot);
    } catch (error) {
      console.log("Error occurred when load my plan", error);
    }
  };

  const handleNavigate = (path, isLogout = false) => {
    if (isLogout) {
      setLogoutModalOpen(true);
    } else {
      navigate(path);
    }
    setOpen(false);
  };

  const getCurrentActiveAddress = async () => {
    const latLong = await getCoordinates();
    if (latLong) {
      const address = await getLocationDetails(
        latLong.latitude,
        latLong.longitude
      );
      setCurrentActiveAddress(address);
    }
  };

  const fetchKycDetails = async () => {
    const response = await fetchKYC();
    setKycDetails(response?.data?.data);
  };

  // ----------- use effect ----------
  useEffect(() => {
    // loadWalletData();
    loadMyPlan();
    fetchKycDetails();
    // hydrate from context cart immediately for instant UI update
    if (cart) setCartItems(cart);
    // also ensure freshness from API
    refreshCart();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (cart) setCartItems(cart);
  }, [cart]);

  useEffect(() => {
    loadWalletSummary();
    getCurrentActiveAddress();
    setSelectedLocation(currentActiveAddress?.city);
  }, []);

  useEffect(() => {
    if (currentActiveAddress) {
      setSelectedLocation(currentActiveAddress?.city);
    }
  }, [currentActiveAddress]);

  useEffect(() => {
    switch (pathName) {
      case "home": {
        setSearchInputText(
          "Search tournaments, podcasts, product, auction by name"
        );
        break;
      }
      case "live-tournaments": {
        setSearchInputText("Search live tournaments by name");
        break;
      }
      case "upcoming-tournaments": {
        setSearchInputText("Search upcoming tournament by name");
        break;
      }
      case "past-tournaments": {
        setSearchInputText("Search past tournament by name");
        break;
      }
      case "private-tournaments": {
        setSearchInputText("Search tournaments by name");
        break;
      }
      case "stores": {
        setSearchInputText("Search stores by name");
        break;
      }
      // case "live-stream": {
      //   setSearchInputText("Search live stream by name");
      //   break;
      // }
      case "auctions": {
        setSearchInputText("Search auctions by name");
        break;
      }
      case "podcasts": {
        setSearchInputText("Search podcasts by name");
        break;
      }
      case "forums": {
        setSearchInputText("Search forums by name");
        break;
      }
    }
  }, []);
  return (
    <>
      <Navbar expand="lg" className="custom-navbar" variant="dark">
        <Container fluid>
          <div className="header-main-container">
            <Navbar.Brand className="brand-logo">
              <div className="mobile-toogle-btn">
                <Button
                  type="link"
                  className="sidebar-toggler ps-0"
                  onClick={() => onPress()}
                >
                  <AlignJustify />
                </Button>
              </div>
              <div className="logo" onClick={() => navigate("/home")}>
                <img src={LogoImage} />
              </div>
            </Navbar.Brand>

            <div className="searchbar-new">
              <Input
                // placeholder="Search live stream, products & more..."
                placeholder={searchInputText}
                className="antd-search-input"
                onChange={(e) => setGlobalSearch(e.target.value)}
                prefix={<img src={SearchIconImage} />}
              />
            </div>
            <Nav className="navbar-mainclass-right">
              <Nav.Item className="location-text">
                <Dropdown overlay={locationMenu} trigger={["click"]}>
                  <div
                    className="location-header"
                    style={{ cursor: "pointer" }}
                  >
                    <img src={LocationIcon} alt="location" />
                    <span>
                      Delivery: {selectedLocation}
                      <DownOutlined style={{ marginLeft: 4, fontSize: 10 }} />
                    </span>
                  </div>
                </Dropdown>
              </Nav.Item>

              {/* Coins */}
              <Nav.Item className="coins-box">
                <img src={CoinIcon} />
                {Number(walletSummary?.wallet?.total_balance).toFixed(2)}
              </Nav.Item>

              <div className="chat-butoon-hide header-chat-button">
                <img
                  onClick={() => navigate("/chat")}
                  src={MessageIcon}
                  alt="location"
                />
              </div>
              <div
                className="notifications-button"
                onClick={() => navigate("/notifications")}
              >
                <img src={NotificationIcon} alt="location" />
              </div>
              <div className="desktop-profile-view">
                <div className="profile-dropdown-wrapper" ref={dropdownRef}>
                  {/* Profile Header */}
                  <div
                    className="profile-dropdown-toggle"
                    onClick={() => setOpen(!open)}
                  >
                    <div className="kyc-badge">{`${
                      kycDetails?.status ? kycDetails?.status : "Unverified"
                    } KYC`}</div>
                    <div className="profile-info">
                      <img
                        src={TrofieUserImage}
                        alt="trophy"
                        className="trophy-icon"
                      />
                      <div className="header-profilename">
                        <span className="username">{userProfile?.name}</span>
                        <div className="user-position">
                          {subscriptionPlan?.name?.en}
                        </div>
                      </div>
                      <DownOutlined
                        style={{ color: "#fff", fontSize: "14px" }}
                      />
                    </div>
                  </div>

                  {/* Dropdown Menu */}
                  {open && (
                    <div className="custom-dropdown-menu">
                      {menuItems?.map((item) => (
                        <div
                          key={item.label}
                          className="dropdown-item"
                          onClick={() =>
                            handleNavigate(item.path, item.isLogout)
                          }
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile-profile-view">
                <div
                  className="profile-dropdown dropdown-toggle"
                  onClick={() => setProfileDrawerOpen(true)}
                >
                  <Space>
                    <img src={TrofieUserImage} alt="profile" />
                    <div className="header-profilename">
                      <span>{profile?.name}</span>
                      <div className="user-postion-name">Iconic</div>
                    </div>
                  </Space>
                </div>
              </div>
              <Drawer
                title={
                  <div className="profile-sidebar-headding">
                    <h6>Hi, {profile?.name}</h6>
                    <div className="profile-coine-count">
                      <img src={CoinSmallIcon} alt="coine" /> My Tokens{" "}
                      {profile?.balance}
                    </div>
                  </div>
                }
                placement="right"
                onClose={() => setProfileDrawerOpen(false)}
                open={profileDrawerOpen}
                className="profile-drawer"
                width={320}
              >
                <div className="drawer-section">
                  <ul>
                    {menuItems1?.map((item) => (
                      <li
                        key={item.label}
                        className={activeItem === item.label ? "active" : ""}
                        onClick={() => handleClick(item.label, item.path)}
                      >
                        {item.icon} {item.label}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="drawer-section">
                  <ul>
                    {menuItems2?.map((item) => (
                      <li
                        key={item.label}
                        className={activeItem === item.label ? "active" : ""}
                        onClick={() =>
                          handleClick(item.label, item.path, item.isLogout)
                        }
                      >
                        {item.icon} {item.label}
                        {/* {item.switch} */}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="app-store-image">
                  <img src={Googleplaystore} alt="Google Play" />
                  <img src={Applestore} alt="App Store" />
                </div>
              </Drawer>

              <Nav.Item>
                <Button
                  className="Fill-button Fill-buttonheader"
                  onClick={() => setCartDrawerOpen(true)}
                >
                  <img src={ShoopingImage} /> {cartItems?.items?.length}
                </Button>
              </Nav.Item>
            </Nav>
          </div>
        </Container>
      </Navbar>
      <CartListingDrawer
        open={cartDrawerOpen}
        setOpen={setCartDrawerOpen}
        cartItemsData={cartItems}
        loadCartItemsData={loadCartItemsData}
      />
      <CustomeModal
        open={logoutModalOpen}
        title="Logout?"
        message="Are you sure you want to logout?"
        okText="Yes, Logout"
        cancelText="Cancel"
        onOk={confirmLogout}
        width={508}
        onCancel={() => setLogoutModalOpen(false)}
      />
    </>
  );
};

export default Header;
